angular.module('edxComponents')
  .component('edxNweaGradeBandDropdown', {
    templateUrl: '/resources/components/assign-focus/create-nwea-assignment/nwea-grade-band-dropdown.component.html',
    controller: ['edxNweaAssignmentService', NweaGradeBandDropdownController],
    controllerAs: 'vm',
    bindings: {
      onSelect: '&edxOnSelect',
      disabled: '<edxDisabled',
      grade: '<edxStudentGrade',
      studentId: '<edxStudentId',
      levelId: '<edxLevelId'
    }
  });

function NweaGradeBandDropdownController(nweaAssignmentService) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.isDisabled = isDisabled;
  vm.onClick = onClick;

  vm.selected = undefined;
  vm.loading = true;

  function $onInit() {

    nweaAssignmentService.loadGradeBandsForStudent(vm.studentId).then(function (grades) {
      vm.gradeBands = grades;
      vm.selected = defaultGradeBand(vm.gradeBands);
    }).catch(function(){
      vm.gradeBands = [];
    }).finally(function(){
      vm.loading = false;
      vm.onSelect({level: vm.selected});
    });

    vm.loading = false;
  }

  function isDisabled() {
    return !vm.gradeBands || vm.gradeBands.length <= 0 || vm.disabled;
  }

  function onClick(model) {
    vm.onSelect({level: model});
  }

  /**
   * Converts grade number to lookup ID for grade band
   * @param studentGrade
   */
  function defaultGradeBand(gradeBands) {
    var bandID = "K-2";
    
    if(vm.grade >= 6) {
      bandID = "6+";
    } else if(vm.grade >= 2) {
      bandID = "2-5";
    }

    return gradeBands.find(function(gradeBand){
        return gradeBand.name.indexOf(bandID) >= 0;
    });
  }
}
